<template>
  <div class="forum-list">
    <Header 
      title="Forum" 
      firstButtonLabel="Criar post"
      :firstButtonRoute="{ name: 'ForumCreate' }"
      firstButtonVariant="primary"
    ></Header>
      <!-- subtitle="Posts da galera :)" -->
    <div class="container">

      <div class="stats-table table-responsive">
        <table class="table is-hoverable team1">
          <!-- <thead>
            <tr>
              <th>Post</th>
              <th>última atualização</th>
              <th>respostas</th>
            </tr>
          </thead> -->
          <!-- <tbody> -->
            <tbody v-for="category in forum_posts.categories" :key="category.id">
              <tr>
                <td colspan="0">
                  <strong>
                    {{category.name || 'sem categoria'}}
                  </strong>
                </td>
                <td>
                  <strong>última atualização</strong>
                </td>
                <td>
                  <strong>respostas</strong>
                </td>
              </tr>
              <tr v-for="forum_post in category.forum_posts" :key="forum_post.id">
                <td class="forum-post">
                  <div>
                    <router-link :to="{ name: 'ForumSingle', params: { id: forum_post.id }}" class="forum-link">
                      <h4 v-html="forum_post.title"></h4>
                      <!-- <b-badge variant="light">offtopic</b-badge> -->
                    </router-link>
                    <!-- <p>This is a huge release. It contains some massive behind-the-scenes changes which will make Flarum more reliable and streamline extension development going forward. There are also a few nifty new features, and plenty of bug fixes.</p> -->
                    <p>
                      <router-link :to="{ name: 'UserSingle', params: { id: forum_post.user.id }}">
                        {{forum_post.user.nickname}}
                      </router-link>
                    </p>
                  </div>
                </td>
                <td>
                  <span>{{forum_post.created_at_friendly}}</span>
                </td>
                <td>
                  <p class="replies">{{forum_post.forum_responses_count}} respostas</p>
                </td>
              </tr>
              <tr v-if="forum_posts.length == 0">
                <td colspan="3">
                  <p style="text-align: center">
                    ninguém postou ainda :(<br>
                    não tenha vergonha, <router-link to="/forum/new">crie um post agora</router-link>
                  </p>
                </td>
              </tr>
            </tbody>



          <!-- </tbody> -->
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'ForumList',
  metaInfo: {
    title: 'Forum'
  },
  data () {
    return {
      forum_posts: []
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('forum_posts.json')
        .then(response => (this.forum_posts = response.data))
    }
  },
  mounted () {
    this.initialize()
    this.$store.dispatch('removeForumUnread')
  },
  components: {
    Header
  }
}
</script>

<style lang="sass" scoped>
.forum-post
  padding: 5px 10px !important
  h4
    margin: 0
    font-size: 17px
  p
    margin: 0
    font-size: 12px
.stats-table
  p, span
    margin: 0
    font-size: 12px
</style>
